export const darkBlue = "#17395C"
export const lightBlue = "#A3C3CE"